import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import FeatureRendererType from '@jbrowse/core/pluggableElementTypes/renderers/FeatureRendererType';
import ReactComponent from './components/DivSequenceRendering';
import configSchema from './configSchema';
/* adjust in both directions */
var DivSequenceRenderer = /*#__PURE__*/function (_FeatureRendererType) {
  _inherits(DivSequenceRenderer, _FeatureRendererType);
  function DivSequenceRenderer() {
    var _this;
    _classCallCheck(this, DivSequenceRenderer);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(DivSequenceRenderer).apply(this, arguments));
    _this.supportsSVG = true;
    return _this;
  }
  _createClass(DivSequenceRenderer, [{
    key: "getExpandedRegion",
    value: function getExpandedRegion(region) {
      return _objectSpread({}, region, {
        start: Math.max(region.start - 3, 0),
        end: region.end + 3
      });
    }
  }]);
  return DivSequenceRenderer;
}(FeatureRendererType);
export default (function (pluginManager) {
  pluginManager.addRendererType(function () {
    return new DivSequenceRenderer({
      name: 'DivSequenceRenderer',
      ReactComponent: ReactComponent,
      configSchema: configSchema,
      pluginManager: pluginManager
    });
  });
});